import { atom } from 'recoil';
import { IResultadoRealizacaoCompetencia } from '../../commons/types/analisePerfil';


export const perfilCompetenciasAtom = atom<IResultadoRealizacaoCompetencia[]>({
  key: 'perfilCompetencias', 
  default: [] as IResultadoRealizacaoCompetencia[],
}); 
